import Player from "../../player";
import {CMSContentType} from "../CMSType";
import {BaseContentItem, BaseContentItemParams, BaseContentItemDTO} from "./base.content";
import {BaseListContentParams, BaseListContent} from "./list.abstract.content";
import {AContentDTO} from "../base.content";

interface PlayerListContentItemParams extends BaseContentItemParams {
  player_id: string;
  number: number;
}

const defaultParams = {} as PlayerListContentItemParams;

export class PlayerListContentItem extends BaseContentItem {
  readonly player_id: string;
  readonly number: number;

  get id() {
    return this.player_id;
  }

  get name() {
    return this.primaryText;
  }

  get role() {
    return this.secondaryText;
  }

  get mediumPhoto() {
    return this.avatar;
  }

  constructor(data: PlayerListContentItemParams = defaultParams) {
    super(data);
    this.player_id = data.player_id;
    this.number = data.number;
  }

  static fromPlayer(player: Player): PlayerListContentItem  {
    return new PlayerListContentItem({
      player_id: player.id,
      number: player.number,
      primaryText: player.name,
      secondaryText: player.role,
      avatar: player.photo
    });
  }

  static toPlayer(player: PlayerListContentItemDTO): Player  {
    return new Player({
      id: player.player_id,
      number: player.number,
      name: player.primaryText,
      position: player.secondaryText,
      photo: player.avatar
    });
  }

  equals(toCompare: PlayerListContentItem) {
    return this.player_id === toCompare.player_id;
  }

  public toJSON() {
    return Object.assign(super.toJSON(), {
      player_id: this.player_id,
      number: this.number
    });
  }
}

export interface PlayerListContentParams extends BaseListContentParams<PlayerListContentItem> {
  label: string;
}
export interface PlayerListContentDTO extends AContentDTO {
  label: string;
  items: PlayerListContentItemDTO[];
}
export interface PlayerListContentItemDTO extends BaseContentItemDTO {
  player_id: string;
  number: number;
}

const defaultListParams = {} as PlayerListContentParams;

export class PlayerListContent extends BaseListContent<PlayerListContentItem> {
  public label: string;
  constructor(data: PlayerListContentParams = defaultListParams) {
    super(CMSContentType.playerList, data);
    this.label = data.label;
  }

  setLabel(value: string): PlayerListContent {
    this.label = value;
    return this;
  }

  public addPlayer(player: Player): PlayerListContent {
    if (!this.containsPlayer(player)) {
      return <PlayerListContent> this.push(PlayerListContentItem.fromPlayer(player));
    }

    return this;
  }

  public removePlayer(player: Player): PlayerListContent {
    if (this.containsPlayer(player)) {
      return this.remove(this.items.find(
        (playerListItem: PlayerListContentItem) => playerListItem.player_id === player.id
      ))
    }
    return this;
  }

  public containsPlayer(player: Player): boolean {
    return this.items.filter((item: PlayerListContentItem) => item.player_id === player.id).size > 0;
  }
}




// WEBPACK FOOTER //
// ./src/api/club-cms/content/player-list.content.ts